// 1. Prima carica jQuery e rendilo globale SINCRONO
const jquery = require('jquery');
const $ = window.jQuery = jquery;

// 2. POI carica SignalR
require('signalr');

// 3. Carica gli hub autogenerati
require('@/hubs/hubs')

class SignalRManager {
    constructor() {
        this.hubs = {}
        this.reconnectDelay = 5000
        this.reconnecting = false
    }

    connect({
                url,
                hubs = {},
                qs = {},
                onConnected,
                onDisconnected,
                onReconnecting,
                onReconnected,
                onError
            }) {
        $.connection.hub.url = url

        // Imposta query string
        if (qs && Object.keys(qs).length > 0) {
            $.connection.hub.qs = Object.entries(qs)
                .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
                .join('&')
        }

        // Inizializza hub
        Object.keys(hubs).forEach(hubName => {
            const hubProxy = $.connection[hubName]
            if (!hubProxy) throw new Error(`Hub non trovato: ${hubName}`)

            this.hubs[hubName] = { proxy: hubProxy, callbacks: hubs[hubName] }

            // registra callback server → client
            Object.keys(hubs[hubName]).forEach(eventName => {
                hubProxy.client[eventName] = hubs[hubName][eventName]
            })
        })

        // Gestione disconnect/reconnect
        $.connection.hub.disconnected(() => {
            if (onDisconnected) onDisconnected()

            if (!this.reconnecting) {
                this.reconnecting = true
                if (onReconnecting) onReconnecting()

                setTimeout(() => {
                    $.connection.hub.start()
                        .done(() => {
                            this.reconnecting = false
                            if (onReconnected) onReconnected()
                        })
                        .fail(err => { if (onError) onError(err) })
                }, this.reconnectDelay)
            }
        })

        return $.connection.hub.start()
            .done(() => { if (onConnected) onConnected() })
            .fail(err => { if (onError) onError(err) })
    }

    call(hubName, method, ...args) {
        const hub = this.hubs[hubName]
        if (!hub) throw new Error(`Hub non registrato: ${hubName}`)
        return hub.proxy.server[method](...args)
    }

    stop() {
        $.connection.hub.stop()
    }
}

export default new SignalRManager()
